export default {
  methods: {
    calculateScore(entry) {
      if (entry.data.stoolDescription) {
        const numberOfMovements = parseInt(entry.data.bowelMovements / 10);

        const typesChosen = parseInt(entry.data.stoolDescription.length);

        const description = entry.data.stoolDescription;
        const multiplier = numberOfMovements / typesChosen;

        const total = description.reduce(
          (previousValue, currentValue) =>
            parseInt(previousValue) + parseInt(currentValue),
          0
        );

        const multipliedTotal = total * multiplier;

        const score = multipliedTotal / numberOfMovements;

        // Return the average score.
        return Math.trunc(score);
      }
    },
  },

  computed: {
    score() {
      return this.calculateScore(this.existingEntry);
    },
  },
};
